export interface RatingQuestionAnswer {
  ratingQuestionId: string;
  answerYN: boolean;
  additionalComment: string;
}
